import { useState } from 'react';

import { highlightText } from '../utils/utils';
import { ReadMoreCellProps } from '../interfaces';

function MehrLesenCell({ text, filterText, tooltipText }:ReadMoreCellProps) {
  const [readMore, setReadMore] = useState(false);

  function showReducedText(txt:string):string {
    const slicedText:string = txt.slice(0, 155);

    return slicedText.slice(0, slicedText.lastIndexOf(' ')) + ' ...';
  }

  function handleClick(event: React.MouseEvent) {
    event.stopPropagation();
    setReadMore(!readMore);
  }

  return (
    text.length > 155 ? 
      (
        <>
          <div className={readMore ? 'display-none' : 'display-block'}>{highlightText(showReducedText(text), filterText)}</div>
          <div className={readMore ? 'display-block' : 'display-none'}>{highlightText(text, filterText)}</div>
          <button 
            type="button" 
            className={readMore ? 'read-more-button arrow-up' : 'read-more-button arrow-down'} 
            title={readMore ? 'Verkürzten ' + tooltipText : 'Vollständigen ' + tooltipText}
            onClick={handleClick}
          >
            {readMore ? 'verkürzten Text anzeigen' : 'vollständigen Text anzeigen'}
          </button>
        </> 
      ) : (
        <div>
          {highlightText(text, filterText)}
        </div>
      )
  );
}

export default MehrLesenCell;
